export function IsTileAddress(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.x !== undefined && b.y !== undefined && b.levelOfDetail !== undefined;
}
export function IsArrayOfTileAddress(b) {
    if (Array.isArray(b) && b.length) {
        for (let i = 0; i != b.length; i++) {
            if (IsTileAddress(b[i])) {
                return true;
            }
        }
    }
    return false;
}
export var NeighborsAddress;
(function (NeighborsAddress) {
    NeighborsAddress[NeighborsAddress["NW"] = 0] = "NW";
    NeighborsAddress[NeighborsAddress["N"] = 1] = "N";
    NeighborsAddress[NeighborsAddress["NE"] = 2] = "NE";
    NeighborsAddress[NeighborsAddress["W"] = 3] = "W";
    NeighborsAddress[NeighborsAddress["A"] = 4] = "A";
    NeighborsAddress[NeighborsAddress["E"] = 5] = "E";
    NeighborsAddress[NeighborsAddress["SW"] = 6] = "SW";
    NeighborsAddress[NeighborsAddress["S"] = 7] = "S";
    NeighborsAddress[NeighborsAddress["SE"] = 8] = "SE";
})(NeighborsAddress || (NeighborsAddress = {}));
export function IsTile(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.address !== undefined && b.content !== undefined;
}
export function IsArrayOfTile(b) {
    if (Array.isArray(b) && b.length) {
        for (let i = 0; i != b.length; i++) {
            if (IsTile(b[i])) {
                return true;
            }
        }
    }
    return false;
}
export function IsTileConstructor(obj) {
    return typeof obj === "function" && !!obj.prototype && "value" in obj.prototype;
}
export function IsTileCollection(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return (b.count !== undefined &&
        b.has !== undefined &&
        b.get !== undefined &&
        b.getAll !== undefined &&
        b.add !== undefined &&
        b.addAll !== undefined &&
        b.remove !== undefined &&
        b.removeAll !== undefined &&
        b.clear !== undefined &&
        b.intersect !== undefined);
}
export var CellCoordinateReference;
(function (CellCoordinateReference) {
    CellCoordinateReference[CellCoordinateReference["CENTER"] = 0] = "CENTER";
    CellCoordinateReference[CellCoordinateReference["NW"] = 1] = "NW";
    CellCoordinateReference[CellCoordinateReference["NE"] = 2] = "NE";
    CellCoordinateReference[CellCoordinateReference["SW"] = 3] = "SW";
    CellCoordinateReference[CellCoordinateReference["SE"] = 4] = "SE";
})(CellCoordinateReference || (CellCoordinateReference = {}));
export function IsTileSystemBounds(b) {
    if (b === null || typeof b !== "object")
        return false;
    return (b.minLOD !== undefined &&
        b.maxLOD !== undefined &&
        b.minLatitude !== undefined &&
        b.maxLatitude !== undefined &&
        b.minLongitude !== undefined &&
        b.maxLongitude !== undefined);
}
export function IsTileMetricsProvider(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.metrics !== undefined;
}
export function IsTileDatasource(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.fetchAsync !== undefined && b.metrics !== undefined;
}
//# sourceMappingURL=tiles.interfaces.js.map